<!--Login Page Starts-->
<section id="login">
  <div class="row full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="fondo-login d-flex align-items-center justify-content-center">
        <div class="card overflow-hidden">
          <div class="card-content">
            <div class="card-body">
              <div class="row m-0">
                <div class="col-12 justify-content-center align-items-center">
                  <img
                    src="assets/img/logo.png"
                    alt="logo"
                    class="img-fluid logo-login"
                    width="250"
                  />
                  <h4 class="text-center mt-2 text-white">Iniciar sesión</h4>
                  <form
                    autocomplete="off"
                    [formGroup]="user"
                    (ngSubmit)="guardar()"
                  >
                    <div class="form-group">
                      <input
                        class="form-control rounded"
                        type="email"
                        placeholder="Correo electrónico"
                        formControlName="email"
                        [class.is-invalid]="correoNoValido"
                      />
                      <small
                        *ngIf="correoNoValido"
                        class="text-danger text-left white"
                      >
                        Formato de correo no valido
                      </small>
                    </div>

                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          [type]="fieldTextType ? 'text' : 'password'"
                          placeholder="Contraseña"
                          formControlName="password"
                          [class.is-invalid]="pass1NoValido"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !fieldTextType,
                                'fa-eye': fieldTextType
                              }"
                              (click)="toggleFieldTextType()"
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <p
                        style="text-align: left; margin-left: 10px"
                        class="text-white"
                      >
                        <input
                          formControlName="recordarme"
                          class="input-checkbox100"
                          id="ckb1"
                          type="checkbox"
                          name="remember-me"
                        />
                        Recordar mi usuario
                      </p>
                    </div>

                    <div class="form-group row">
                      <div class="input-group">
                        <button
                          type="submit"
                          [disabled]="!user.valid"
                          class="btn btn-secondary btn-block"
                        >
                          Entrar
                        </button>
                      </div>
                    </div>
                  </form>
                  <div class="card-footer" style="cursor: pointer">
                    <div class="float-left mb-2 text-white">
                      <a (click)="onForgotPassword()"
                        ><i class="fa fa-unlock"></i> Recuperar Contraseña</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer class="container-fluid"></app-footer>
</section>
<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" src="../../../assets/img/logo-empresa.png" />
</div>
